import { Link } from "react-router-dom";

import ColoredMarker from "../../../common/components/ColoredMarker";
import { IDwelling } from "../reducers";
import { DWELLING_DETAILS } from "../routes";
import DwellingDetailBadgesComponent from "./DwellingDetailBadgesComponent";

export interface DwellingDataGridBadgeComponentProps {
  dwelling: IDwelling;
  linkEnable?: boolean;
}

const DwellingDataGridBadgeComponent = ({
  dwelling,
  linkEnable = true,
}: DwellingDataGridBadgeComponentProps) => {
  return dwelling.id !== undefined ? (
    <div className="d-flex flex-column property-address gap-1">
      {linkEnable ? (
        <Link
          to={DWELLING_DETAILS.replace(
            ":id",
            dwelling.datedReference || dwelling.id,
          )}
          className="propertyAdressLink"
        >
          {dwelling.address.address.address}, {dwelling.address.address.zip}{" "}
          {dwelling.address.address.city}
        </Link>
      ) : (
        <span className="propertyAdressLink">
          {dwelling.address.address.address}, {dwelling.address.address.zip}{" "}
          {dwelling.address.address.city}
        </span>
      )}
      <DwellingDetailBadgesComponent dwelling={dwelling} />
    </div>
  ) : (
    <div className="d-flex flex-column property-address">
      <ColoredMarker color="grey">Aucune information</ColoredMarker>
    </div>
  );
};

export default DwellingDataGridBadgeComponent;
